import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {IWorkLog} from "../../../../../../../utils/interfaces/my_projects/IWorkLog";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiGetWorkLog = (pk: number | undefined): UseQueryResult<IWorkLog, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(pk: number | undefined): Promise<IWorkLog> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/my_projects/work_logs/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetWorkLog", pk],
        queryFn: () => doGet(pk),
        enabled: !!pk,
    })

};

export default useApiGetWorkLog